module.exports = __webpack_public_path__ + "img/laboratorio_4-3_682.ce1a37ec.webp";